/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
//Query String
  /* No need to edit this*/
(function () {
  'use strict';
  var queryString = {};

  queryString.parse = function (str) {
    if (typeof str !== 'string') {
      return {};
    }

    str = str.trim().replace(/^\?/, '');

    if (!str) {
      return {};
    }

    return str.trim().split('&').reduce(function (ret, param) {
      var parts = param.replace(/\+/g, ' ').split('=');
      var key = parts[0];
      var val = parts[1];

      key = decodeURIComponent(key);
      // missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      val = val === undefined ? null : decodeURIComponent(val);

      if (!ret.hasOwnProperty(key)) {
        ret[key] = val;
      } else if (Array.isArray(ret[key])) {
        ret[key].push(val);
      } else {
        ret[key] = [ret[key], val];
      }

      return ret;
    }, {});
  };

  queryString.stringify = function (obj) {
    return obj ? Object.keys(obj).map(function (key) {
      var val = obj[key];

      if (Array.isArray(val)) {
        return val.map(function (val2) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(val2);
        }).join('&');
      }

      return encodeURIComponent(key) + '=' + encodeURIComponent(val);
    }).join('&') : '';
  };

  queryString.push = function (key, new_value) {
    var params = queryString.parse(location.search);
    params[key] = new_value;
    var new_params_string = queryString.stringify(params)
    history.pushState({}, "", window.location.pathname + '?' + new_params_string);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = queryString;
  } else {
    window.queryString = queryString;
  }
})();

let manualSort = document.body.getAttribute('data-manual-sort');
let selectedColorSwatch;

window.PXUTheme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }
    if (this.enable_filter == true || this.enable_sorting == true) {

      $('#sort').val('created-descending');

      if (!manualSort) {
        // queryString.push('sort_by', $('#sort').val());
      }

      $('.sort-type').click(function () {
        const _this = $(this);

        $('#sort').val(_this.data('sort'));
        //  queryString.push('sort_by', $('#sort').val());

        $('.sort-type').removeClass('active');
        _this.addClass('active');
        window.PXUTheme.jsCollection.filterURL(false);

        window.PXUTheme.jsCollection.closeColumns('right-column');
      });

      let i = 0;
      $('.columns.eight').each(function () {
        if ($(this).find('input').prop('checked')) {
          $(this).addClass('is-active');
          if ('color' === $(this).data('filter-type')) {
            selectedColorSwatch = $(this).find('input').val();
            console.log(selectedColorSwatch);
            setTimeout(function () {
              window.PXUTheme.jsCollection.switchProductSwatchToSelected($('.collection-matrix .product__grid-item'));
            }, 666);
          }
          i++;
        } else {
          $(this).removeClass('is-active');
        }
      });
      $('.selected-filters').html('(' + i + ')');

      // Clears ALL Filters
      $('.clear-filters').click(function () {
        //reset sort by column
        $('#sort').val('created-descending');
        $('.sort-type').removeClass('active');
        $('[data-sort="created-descending"]').addClass('active');

        //reset filter column
        $('.is-active').children().find('input').prop('checked', false);
        $('.is-active').removeClass('is-active');
        window.PXUTheme.jsCollection.filterURL(true);
        window.PXUTheme.jsCollection.multiTagFilter.updateFilterCount(true);

        window.PXUTheme.jsCollection.closeColumns('left-column');
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));

    });
    $('body').on('click', '.columns.eight', function (e) {
      e.preventDefault();

      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        $(this).children().find('input').prop('checked', false);
        window.PXUTheme.jsCollection.filterURL(false);
      } else {
        //this should remove the checks from other input in the same category
        $(this).siblings().find('input').prop('checked', false);
        $(this).siblings().find('input').removeAttr('checked');

        $(this).find('input').prop('checked', true);
        window.PXUTheme.jsCollection.multiTagFilter.init($(this));
        window.PXUTheme.scrollToTop($('.collection__content'));
      }

      //window.PXUTheme.jsCollection.closeColumns('left-column');
    });
  },
  switchProductSwatchToSelected: function switchProductSwatchToSelected(swatchElements) {
    let colorList = window.PXUTheme.jsCollection.getSwatchColorList();
    $(swatchElements).each(function () {
      $(this).find('.thumbnail-swatch .swatch').each(function () {

        let swatchColor = $(this).data('swatch-label');
        let lookup = colorList[swatchColor];

        if ($.inArray(selectedColorSwatch, lookup) !== -1) {
          console.log(swatchColor, lookup, selectedColorSwatch);
          let $swap = $(this).find('span[data-image]');
          $($swap).css('border', '1px solid black');
          //$swap.trigger('click');
          //if ($swap.data('image').indexOf('no-image') == -1) {

          let productImg = $swap.parents('.thumbnail').find('.product__imageContainer img');
          let swapImg = $swap.data('image');
          setTimeout(function () {
            productImg.attr('src', swapImg);
            productImg.attr('srcset', swapImg);
            //productImg.data('src', swapImg);
            //productImg.data('srcset', swapImg);
          }, 666);
          //}
          return false;
        }
      });
    });

  },
  getSwatchColorList: function getSwatchColorList() {
    return JSON.parse(document.getElementById('swatch-master-list').innerHTML);

  },
  closeColumns: function closeColumns(side) {
    let targetHash = '#' + side;
    let $target = $('#' + side);
    if (side == 'left-column') {
      $target.removeClass('open-side');
      $('a[href="' + targetHash + '"]').removeClass('open-side');
      $('.matrix__wrapper').removeClass('smaller-grid');
    } else {
      $target.removeClass('open-side');
      $('a[href="' + targetHash + '"]').removeClass('open-side');
      $('.matrix__wrapper').removeClass('smaller-grid');
    }
  },
  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (window.PXUTheme.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    selectedColorSwatch = $('[data-filter-type="color"]').find('input:checked').val();
    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    window.PXUTheme.queryParameters.sort_by = query;
    query = '?' + $.param(window.PXUTheme.queryParameters);

    this.processUrl(path, currentTags, query);
    console.log(`5150 filterURL: ${selectedOptions.length}`)

    window.PXUTheme.jsCollection.multiTagFilter.updateFilterCount(false, selectedOptions.length);
    setTimeout(function () {
      window.PXUTheme.jsCollection.switchProductSwatchToSelected($('.collection-matrix .product__grid-item'));
    }, 666);
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function(data) {
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Get and set new breadcrumb html
      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      // Remove loading animation
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Check for products
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      // Initiate infinite scrolling on new products appended to collection grid
      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }

      setTimeout(function () {
        window.PXUTheme.jsCollection.switchProductSwatchToSelected($('.collection-matrix .product__grid-item'));
      }, 666);
    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex;
      if (window.PXUTheme.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      window.PXUTheme.jsCollection.filterURL();
    }
  },
  updateFilterCount: function updateFilterCount(clearAll, tagCount) {
    if (clearAll) {
      $('.selected-filters').html('(0)');
    } else {

      let filtersArray = url().substring(url().lastIndexOf("/") + 1);
      filtersArray = filtersArray.substring(0, filtersArray.indexOf('?'));
      filtersArray = filtersArray.split("+");

      let selectedFiltersCount = filtersArray.length;
      $('.selected-filters').html(`(${selectedFiltersCount})`);


      if (tagCount < selectedFiltersCount) {
        $('.selected-filters').html(`(${tagCount})`);
      } else if (tagCount > 1) {
        $('.selected-filters').html(`(${tagCount})`);
      } else {
        $('.selected-filters').html(`(${selectedFiltersCount})`);
      }
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    window.PXUTheme.breadcrumbs.unload();
  }
}

/******/ })()
;